import { render, staticRenderFns } from "./strippay copy 3.vue?vue&type=template&id=225600b5&scoped=true"
import script from "./strippay copy 3.vue?vue&type=script&lang=js"
export * from "./strippay copy 3.vue?vue&type=script&lang=js"
import style0 from "./strippay copy 3.vue?vue&type=style&index=0&id=225600b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225600b5",
  null
  
)

export default component.exports